import toInt from './toInt';

function getQueryInt(name: string, defaultValue?: number): number {
  const result = window.location.search.match(new RegExp(`[?&]${name}=([^&]+)`, 'i'));
  if (!result || result.length < 1) {
    return defaultValue || 0;
  }
  return toInt(result[1]);
}

export default getQueryInt;
